import z from "zod";

interface Flavoring<FlavorT> {
  _type?: FlavorT;
}

export type Flavor<T, FlavorT> = T & Flavoring<FlavorT>;

export type ProductId = Flavor<string, "ProductId">;
export type StoreId = Flavor<string, "StoreId">;
export type UserId = Flavor<string, "UserId">;
export type ChainId = Flavor<string, "ChainId">;
export type LayoutId = Flavor<string, "LayoutId">;
export type ProductGroupId = Flavor<string, "ProductGroupId">;
export type BookkeepingAccountId = Flavor<string, "BookkeepingAccountId">;
export type deviationId = Flavor<string, "deviationId">;
export type tagId = Flavor<string, "tagId">;
export type PaymentMethodId = Flavor<string, "PaymentMethodId">;
export type ReceiptId = Flavor<string, "ReceiptId">;
export type StaffId = Flavor<string, "StaffId">;
export type ReceiptItemId = Flavor<string, "ReceiptItemId">;
export type ReceiptPaymentId = Flavor<string, "ReceiptPaymentId">;
export type SaleId = Flavor<string, "SaleId">;
export type CashRegisterId = Flavor<string, "CashRegisterId">;
export type CashboxId = Flavor<string, "CashboxId">;
export type ControlUnitId = Flavor<string, "ControlUnitId">;
export type DeviceId = Flavor<string, "DeviceId">;
export type EndOfDayReportId = Flavor<string, "EndOfDayReportId">;
export type JournalEntryId = Flavor<string, "JournalEntryId">;
export type CreditNoteId = Flavor<string, "CreditNoteId">;
export type DeviceConfigId = Flavor<string, "DeviceConfigId">;
export type FloorPlanId = Flavor<string, "FloorPlanId">;
export type FloorPlanDecorationId = Flavor<string, "FloorPlanDecorationId">;
export type FloorPlanTableId = Flavor<string, "FloorPlanTableId">;
export type IntegrationId = Flavor<string, "IntegrationId">;
export type BookkeepingVoucherId = Flavor<string, "BookkeepingVoucherId">;
export type GiftCardId = Flavor<string, "GiftCardId">;
export type ProductVariantId = Flavor<string, "ProductVariantId">;
export type BillingItemId = Flavor<string, "BillingItemId">;
export type AvailableBillingItemId = Flavor<string, "AvailableBillingItemId">;
export type PaymentProviderUsageId = Flavor<string, "PaymentProviderUsageId">;
export type SubscriptionId = Flavor<string, "SubscriptionId">;
export type OneTimePurchaseId = Flavor<string, "OneTimePurchaseId">;
export type PrinterId = Flavor<string, "PrinterId">;
export type UnitId = Flavor<string, "UnitId">;
export type BarcodeFormatId = Flavor<string, "BarcodeFormatId">;
export type BundleId = Flavor<string, "BundleId">;
export type ApiKeyId = Flavor<string, "ApiKeyId">;
export type WebhookEndpointId = Flavor<string, "WebhookEndpointId">;
export type WebhookEventId = Flavor<string, "WebhookEventId">;
export type ResellerId = Flavor<string, "ResellerId">;
export type ProductPageId = Flavor<string, "ProductPageId">;
export type ImportJobId = Flavor<string, "ImportJobId">;
export type LabelFormatId = Flavor<string, "LabelFormatId">;
export type ModifierGroupId = Flavor<string, "ModifierGroupId">;
export type ModifierId = Flavor<string, "ModifierId">;
export type TabId = Flavor<string, "TabId">;
export type TabChangeId = Flavor<string, "TabChangeId">;
export type TableId = Flavor<string, "TableId">;
export type PrepStationId = Flavor<string, "PrepStationId">;
export type CourseId = Flavor<string, "CourseId">;
export type PrepTicketId = Flavor<string, "PrepTicketId">;
export type ChatSessionId = Flavor<string, "ChatSessionId">;
export type ChatSessionMessageId = Flavor<string, "ChatSessionMessageId">;
export type ChangeRequestId = Flavor<string, "ChangeRequestId">;
export type StoreFrontId = Flavor<string, "StoreFrontId">;
export type StoreFrontCategoryId = Flavor<string, "StoreFrontCategoryId">;
export type StoreFrontProductId = Flavor<string, "StoreFrontProductId">;
export type OrderWorkflowActionId = Flavor<string, "OrderWorkflowActionId">;
export type OrderEventId = Flavor<string, "OrderEventId">;
export type OrderId = Flavor<string, "OrderId">;
export type CombinedPrepTicketId = Flavor<string, "CombinedPrepTicketId">;
export type PermissionGroupId = Flavor<string, "PermissionGroupId">;
export type ProductSyncJobId = Flavor<string, "ProductSyncJobId">;
export type ProductSyncErrorId = Flavor<string, "ProductSyncErrorId">;
export type StockTakeId = Flavor<string, "StockTakeId">;
export type StockTakeActionId = Flavor<string, "StockTakeActionId">;
export type StockTakeLineId = Flavor<string, "StockTakeLineId">;
export type SupplierId = Flavor<string, "SupplierId">;
export type OfferId = Flavor<string, "OfferId">;
export type CatalogReleaseId = Flavor<string, "CatalogReleaseId">;
export type CatalogReleaseOperationId = Flavor<
  string,
  "CatalogReleaseOperationId"
>;
export type ChainModeActivationJobId = Flavor<
  string,
  "ChainModeActivationJobId"
>;
export type StoreCopyJobId = Flavor<string, "StoreCopyJobId">;
export type StockLocationId = Flavor<string, "StockLocationId">;
export type StockBalanceId = Flavor<string, "StockBalanceId">;
export type StockPolicyId = Flavor<string, "StockPolicyId">;
export type StockMoveId = Flavor<string, "StockMoveId">;
export type StockMoveLineId = Flavor<string, "StockMoveLineId">;
export type StockLedgerEntryId = Flavor<string, "StockLedgerEntryId">;
export type CostPoolId = Flavor<string, "CostPoolId">;
export type AppMessageId = Flavor<string, "AppMessageId">;
export type AppCommandId = Flavor<string, "AppCommandId">;
export type StoreDebtId = Flavor<string, "StoreDebtId">;
export type StoreDebtEventId = Flavor<string, "StoreDebtEventId">;
export type CustomerId = Flavor<string, "CustomerId">;
export type CustomerEventId = Flavor<string, "CustomerEventId">;
export type ServiceOrderId = Flavor<string, "ServiceOrderId">;
export type ServiceOrderEventId = Flavor<string, "ServiceOrderEventId">;
export type ServiceOrderChangeId = Flavor<string, "ServiceOrderChangeId">;
export type ServiceOrderWorkflowActionId = Flavor<
  string,
  "ServiceOrderWorkflowActionId"
>;
export type PreviewBundleId = Flavor<string, "PreviewBundleId">;

export const ProductIdScheme = z.string().transform((x) => x as ProductId);
export const StoreIdScheme = z.string().transform((x) => x as StoreId);
export const UserIdScheme = z.string().transform((x) => x as UserId);
export const ChainIdScheme = z.string().transform((x) => x as ChainId);
export const LayoutIdScheme = z.string().transform((x) => x as LayoutId);
export const ProductGroupIdScheme = z
  .string()
  .transform((x) => x as ProductGroupId);
export const BookkeepingAccountIdScheme = z
  .string()
  .transform((x) => x as BookkeepingAccountId);
export const deviationIdScheme = z.string().transform((x) => x as deviationId);
export const tagIdScheme = z.string().transform((x) => x as tagId);
export const PaymentMethodIdScheme = z
  .string()
  .transform((x) => x as PaymentMethodId);
export const ReceiptIdScheme = z.string().transform((x) => x as ReceiptId);
export const StaffIdScheme = z.string().transform((x) => x as StaffId);
export const ReceiptItemIdScheme = z
  .string()
  .transform((x) => x as ReceiptItemId);
export const ReceiptPaymentIdScheme = z
  .string()
  .transform((x) => x as ReceiptPaymentId);
export const SaleIdScheme = z.string().transform((x) => x as SaleId);
export const CashRegisterIdScheme = z
  .string()
  .transform((x) => x as CashRegisterId);
export const CashboxIdScheme = z.string().transform((x) => x as CashboxId);
export const ControlUnitIdScheme = z
  .string()
  .transform((x) => x as ControlUnitId);
export const DeviceIdScheme = z.string().transform((x) => x as DeviceId);
export const EndOfDayReportIdScheme = z
  .string()
  .transform((x) => x as EndOfDayReportId);
export const JournalEntryIdScheme = z
  .string()
  .transform((x) => x as JournalEntryId);
export const CreditNoteIdScheme = z
  .string()
  .transform((x) => x as CreditNoteId);
export const DeviceConfigIdScheme = z
  .string()
  .transform((x) => x as DeviceConfigId);
export const FloorPlanIdScheme = z.string().transform((x) => x as FloorPlanId);
export const FloorPlanDecorationIdScheme = z
  .string()
  .transform((x) => x as FloorPlanDecorationId);
export const FloorPlanTableIdScheme = z
  .string()
  .transform((x) => x as FloorPlanTableId);
export const IntegrationIdScheme = z
  .string()
  .transform((x) => x as IntegrationId);
export const BookkeepingVoucherIdScheme = z
  .string()
  .transform((x) => x as BookkeepingVoucherId);
export const GiftCardIdScheme = z.string().transform((x) => x as GiftCardId);
export const ProductVariantIdScheme = z
  .string()
  .transform((x) => x as ProductVariantId);
export const BillingItemIdScheme = z
  .string()
  .transform((x) => x as BillingItemId);
export const AvailableBillingItemIdScheme = z
  .string()
  .transform((x) => x as AvailableBillingItemId);
export const PaymentProviderUsageIdScheme = z
  .string()
  .transform((x) => x as PaymentProviderUsageId);
export const SubscriptionIdScheme = z
  .string()
  .transform((x) => x as SubscriptionId);
export const OneTimePurchaseIdScheme = z
  .string()
  .transform((x) => x as OneTimePurchaseId);
export const PrinterIdScheme = z.string().transform((x) => x as PrinterId);
export const UnitIdScheme = z.string().transform((x) => x as UnitId);
export const BarcodeFormatIdScheme = z
  .string()
  .transform((x) => x as BarcodeFormatId);
export const BundleIdScheme = z.string().transform((x) => x as BundleId);
export const ApiKeyIdScheme = z.string().transform((x) => x as ApiKeyId);
export const WebhookEndpointIdScheme = z
  .string()
  .transform((x) => x as WebhookEndpointId);
export const WebhookEventIdScheme = z
  .string()
  .transform((x) => x as WebhookEventId);
export const ResellerIdScheme = z.string().transform((x) => x as ResellerId);
export const ProductPageIdScheme = z
  .string()
  .transform((x) => x as ProductPageId);
export const ImportJobIdScheme = z.string().transform((x) => x as ImportJobId);
export const LabelFormatIdScheme = z
  .string()
  .transform((x) => x as LabelFormatId);
export const ModifierGroupIdScheme = z
  .string()
  .transform((x) => x as ModifierGroupId);
export const ModifierIdScheme = z.string().transform((x) => x as ModifierId);
export const TabIdScheme = z.string().transform((x) => x as TabId);
export const TabChangeIdScheme = z.string().transform((x) => x as TabChangeId);
export const TableIdScheme = z.string().transform((x) => x as TableId);
export const PrepStationIdScheme = z
  .string()
  .transform((x) => x as PrepStationId);
export const CourseIdScheme = z.string().transform((x) => x as CourseId);
export const PrepTicketIdScheme = z
  .string()
  .transform((x) => x as PrepTicketId);
export const ChatSessionIdScheme = z
  .string()
  .transform((x) => x as ChatSessionId);
export const ChatSessionMessageIdScheme = z
  .string()
  .transform((x) => x as ChatSessionMessageId);
export const ChangeRequestIdScheme = z
  .string()
  .transform((x) => x as ChangeRequestId);
export const StoreFrontIdScheme = z
  .string()
  .transform((x) => x as StoreFrontId);
export const StoreFrontCategoryIdScheme = z
  .string()
  .transform((x) => x as StoreFrontCategoryId);
export const StoreFrontProductIdScheme = z
  .string()
  .transform((x) => x as StoreFrontProductId);
export const OrderWorkflowActionIdScheme = z
  .string()
  .transform((x) => x as OrderWorkflowActionId);
export const OrderEventIdScheme = z
  .string()
  .transform((x) => x as OrderEventId);
export const OrderIdScheme = z.string().transform((x) => x as OrderId);
export const CombinedPrepTicketIdScheme = z
  .string()
  .transform((x) => x as CombinedPrepTicketId);
export const PermissionGroupIdScheme = z
  .string()
  .transform((x) => x as PermissionGroupId);
export const ProductSyncJobIdScheme = z
  .string()
  .transform((x) => x as ProductSyncJobId);
export const ProductSyncErrorIdScheme = z
  .string()
  .transform((x) => x as ProductSyncErrorId);
export const StockTakeIdScheme = z.string().transform((x) => x as StockTakeId);
export const StockTakeActionIdScheme = z
  .string()
  .min(1)
  .transform((x) => x as StockTakeActionId);
export const StockTakeLineIdScheme = z
  .string()
  .transform((x) => x as StockTakeLineId);
export const SupplierIdScheme = z.string().transform((x) => x as SupplierId);
export const OfferIdScheme = z.string().transform((x) => x as OfferId);
export const CatalogReleaseIdScheme = z
  .string()
  .transform((x) => x as CatalogReleaseId);
export const CatalogReleaseOperationIdScheme = z
  .string()
  .transform((x) => x as CatalogReleaseOperationId);
export const ChainModeActivationJobIdScheme = z
  .string()
  .transform((x) => x as ChainModeActivationJobId);
export const StoreCopyJobIdScheme = z
  .string()
  .transform((x) => x as StoreCopyJobId);
export const StockLocationIdScheme = z
  .string()
  .transform((x) => x as StockLocationId);
export const StockBalanceIdScheme = z
  .string()
  .transform((x) => x as StockBalanceId);
export const StockPolicyIdScheme = z
  .string()
  .transform((x) => x as StockPolicyId);
export const StockMoveIdScheme = z.string().transform((x) => x as StockMoveId);
export const StockMoveLineIdScheme = z
  .string()
  .transform((x) => x as StockMoveLineId);
export const StockLedgerEntryIdScheme = z
  .string()
  .transform((x) => x as StockLedgerEntryId);
export const CostPoolIdScheme = z.string().transform((x) => x as CostPoolId);
export const AppMessageIdScheme = z
  .string()
  .transform((x) => x as AppMessageId);
export const AppCommandIdScheme = z
  .string()
  .transform((x) => x as AppCommandId);
export const StoreDebtIdScheme = z.string().transform((x) => x as StoreDebtId);
export const StoreDebtEventIdScheme = z
  .string()
  .transform((x) => x as StoreDebtEventId);
export const CustomerIdScheme = z.string().transform((x) => x as CustomerId);
export const CustomerEventIdScheme = z
  .string()
  .transform((x) => x as CustomerEventId);
export const ServiceOrderIdScheme = z
  .string()
  .transform((x) => x as ServiceOrderId);
export const ServiceOrderEventIdScheme = z
  .string()
  .transform((x) => x as ServiceOrderEventId);
export const ServiceOrderChangeIdScheme = z
  .string()
  .transform((x) => x as ServiceOrderChangeId);
export const ServiceOrderWorkflowActionIdScheme = z
  .string()
  .transform((x) => x as ServiceOrderWorkflowActionId);
export const PreviewBundleIdScheme = z
  .string()
  .regex(/^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/)
  .transform((x) => x as PreviewBundleId);
